import React from "react";
import Button from "../button/button";
import Tooltip from "../tooltips/tooltip";
import { GlobalContext } from "../../../utils/globalprovider.js";

import "./toolsbar.css";

class ToolsBar extends React.Component
{
    static contextType = GlobalContext;
    constructor (props)
    {
        super(props);
        this.onClick = this.onClick.bind(this);

    }

    onClick(datas)
    {
        
        this.props.onClick (datas);

    }

    render()
    {

        

        var allitems = [];



        if (this.props.toolsbar.items)
        {

            for (var i=0; i<this.props.toolsbar.items.length; i++)
            {
                switch (this.props.toolsbar.items[i].type)
                {
                    case "button":
                    {
                        
                        var tipbutton = this.props.toolsbar.items[i].en;
                        
                        if (this.context.language == "fr")
                            tipbutton = this.props.toolsbar.items[i].fr;

                        if ('toggle' in this.props.toolsbar.items[i])
                        {
                            allitems.push(
                                <Tooltip text= {tipbutton}>
                                <Button 
                                    nochangecolor = {this.props.toolsbar.items[i].nochangecolor}
                                    
                                    border = {this.props.toolsbar.items[i].value}
                                    disable={this.props.toolsbar.items[i].disable}
                                    image={this.props.toolsbar.items[i].img} 
                                    onClick={this.onClick} 
                                    datas={this.props.toolsbar.items[i].key}
                                    width={this.props.toolsbar.height} 
                                    height={this.props.toolsbar.height}
                                    />
                                    &nbsp;
                                </Tooltip>)

                        }
                        else
                        {

                            if ("currentKey" in this.props)
                            {
                                allitems.push(
                                    <Tooltip text= {tipbutton}>
                                    <Button 
                                        nochangecolor = {this.props.toolsbar.items[i].nochangecolor}
                                        disable={this.props.toolsbar.items[i].disable}
                                        image={this.props.toolsbar.items[i].img} 
                                        inverseColor = {this.props.toolsbar.items[i].key.key == this.props.currentKey}
                                        onClick={this.onClick} 
                                        datas={this.props.toolsbar.items[i].key}
                                        width={this.props.toolsbar.height} 
                                        height={this.props.toolsbar.height}
                                        />
                                        &nbsp;
                                    </Tooltip>
                                )

                            }
                            else
                            {
                                allitems.push(
                                    <Tooltip text= {tipbutton}>
                                    <Button 
                                        nochangecolor = {this.props.toolsbar.items[i].nochangecolor}
                                        disable={this.props.toolsbar.items[i].disable}
                                        image={this.props.toolsbar.items[i].img} 
                                        onClick={this.onClick} 
                                        datas={this.props.toolsbar.items[i].key}
                                        width={this.props.toolsbar.height} 
                                        height={this.props.toolsbar.height}
                                        />
                                        &nbsp;
                                    </Tooltip>
                                )
                            }
                        }
                        
                        break;
                    }
                    case "space":
                        allitems.push(<>&nbsp;&nbsp;</>);
                        break;
                    case "bigspace":
                        allitems.push(<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>);
                        break;
                    }

            }
        }
        else
        {
            // nouveau mode avec families
            var alldivfex = [];
            for (var f = 0; f < this.props.toolsbar.families.length; f++)
            {
                const family = this.props.toolsbar.families[f];
                var allbuttons = [];

                for (var i=0; i<family.items.length; i++)
                {
                    switch (family.items[i].type)
                    {
                        case "button":
                        {
                            
                            var tipbutton = family.items[i].en;
                            
                            if (this.context.language == "fr")
                                tipbutton = family.items[i].fr;


                            if ('toogle' in family.items[i])
                            {
                            allbuttons.push(
                                <Tooltip text= {tipbutton}>
                                <Button 
                                    nochangecolor = {family.items[i].nochangecolor}
                                    disable={family.items[i].disable}
                                    bordertoolbar = {family.items[i].value}
                                    image={family.items[i].img} 
                                    onClick={this.onClick} 
                                    datas={family.items[i].key}
                                    width={this.props.toolsbar.height} 
                                    height={this.props.toolsbar.height}
                                    />
                                    &nbsp;
                                </Tooltip>
                            )
                            }
                            else
                            {
                                allbuttons.push(
                                    <Tooltip text= {tipbutton}>
                                    <Button 
                                        nochangecolor = {family.items[i].nochangecolor}
                                        disable={family.items[i].disable}
                                        image={family.items[i].img} 
                                        
                                        onClick={this.onClick} 
                                        datas={family.items[i].key}
                                        width={this.props.toolsbar.height} 
                                        height={this.props.toolsbar.height}
                                        />
                                        &nbsp;
                                    </Tooltip>
                                )

                            }

                            
                            break;
                        }
                        case "space":
                            allbuttons.push(<>&nbsp;&nbsp;</>);
                            break;
                        case "bigspace":
                            allbuttons.push(<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>);
                            break;
                        }

                }
                alldivfex.push(
                    
                    <div className="toolsbar-flexdiv-family" >
                        <div className="toolsbar-flexdiv-title" >
                            {this.context.language == "fr"?family.fr:family.en}
                        </div>
                        <div className="toolsbar-flexdiv-button" >
                            {allbuttons}
                        </div>
                    </div>
                )



            }
            allitems.push(
                <div className="toolsbar-flexdiv" >
                    {alldivfex}
                </div>
            )

        }

        if (this.props.background)
        {

            return(
            <div className="toolsbarfulldiv" >
                {allitems}
            </div>
            )
        }
        else
        {
            return(
            <div className="toolsbarfulldivNoBackGround" >
                {allitems}
            </div>
            )

        }

    }

}


ToolsBar.defautProps = 
{
    background: true,
}


export default ToolsBar;